<template>
    <div class="language-float-ball" :style="ballStyle" @mousedown="startDrag" @touchstart="startDrag"
        @click="toggleLanguage">
        <div class="ball-content">
            {{ currentLanguage === 'zh' ? '中' : 'EN' }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'LanguageFloatBall',
    props: {
        initialPosition: {
            type: Object,
            default: () => ({
                x: window.innerWidth - 80,
                y: window.innerHeight - 80
            })
        }
    },
    data() {
        return {
            currentLanguage: 'zh',
            isDragging: false,
            position: { ...this.initialPosition },
            startPos: {
                x: window.innerWidth - 80,
                y: window.innerHeight - 80
            }
        }
    },
    computed: {
        ballStyle() {
            return {
                left: `${this.position.x}px`,
                top: `${this.position.y}px`,
                transform: this.isDragging ? 'scale(1.1)' : 'scale(1)'
            }
        }
    },
    mounted() {
        document.addEventListener('mousemove', this.handleDrag);
        document.addEventListener('touchmove', this.handleDrag);
        document.addEventListener('mouseup', this.stopDrag);
        document.addEventListener('touchend', this.stopDrag);
        this.position = localStorage.position ? JSON.parse(localStorage.position) : this.initialPosition;
        // 初始化语言
        this.currentLanguage = localStorage.getItem('lang') || 'zh';
    },
    beforeDestroy() {
        document.removeEventListener('mousemove', this.handleDrag);
        document.removeEventListener('touchmove', this.handleDrag);
        document.removeEventListener('mouseup', this.stopDrag);
        document.removeEventListener('touchend', this.stopDrag);
    },
    methods: {
        startDrag(e) {
            this.isDragging = true;
            const clientX = e.clientX || e.touches[0].clientX;
            const clientY = e.clientY || e.touches[0].clientY;
            this.startPos = {
                x: clientX - this.position.x,
                y: clientY - this.position.y
            };
            e.preventDefault();
        },
        handleDrag(e) {
            if (!this.isDragging) return;
            const clientX = e.clientX || e.touches[0].clientX;
            const clientY = e.clientY || e.touches[0].clientY;

            this.position = {
                x: clientX - this.startPos.x,
                y: clientY - this.startPos.y
            };

        },
        stopDrag() {
            this.isDragging = false;
        },
        toggleLanguage() {
            if (this.isDragging) return;

            this.currentLanguage = this.currentLanguage === 'zh' ? 'en' : 'zh';
            this.$i18n.locale = this.currentLanguage;
            localStorage.setItem('lang', this.currentLanguage);
            this.$message.success(this.currentLanguage === 'zh' ? '切换为中文...' : 'Switch to English...');
            // 添加点击动画
            const ball = this.$el;
            ball.classList.add('click-animate');
            setTimeout(() => {
                localStorage.position = JSON.stringify(this.position);
                ball.classList.remove('click-animate');
                window.location.reload();
            }, 200);
        }
    },
    created() {
        this.currentLanguage = localStorage.getItem('lang') || 'zh';
    },
}
</script>

<style scoped>
.language-float-ball {
    position: fixed;
    width: 50px;
    height: 50px;
    background: linear-gradient(135deg, #5da9ff, #5f85ae);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    font-weight: bold;
    cursor: pointer;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    z-index: 9999;
    transition: transform 0.2s ease, background 0.3s ease;
    user-select: none;
}

.language-float-ball:hover {
    background: linear-gradient(135deg, #5da9ff, #5f85ae);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
}

.ball-content {
    font-size: 16px;
}

.click-animate {
    animation: pulse 0.3s ease;
}

@keyframes pulse {
    0% {
        transform: scale(1);
    }

    50% {
        transform: scale(1.2);
    }

    100% {
        transform: scale(1);
    }
}
</style>
